import {css} from '@emotion/css';

import {colours, coloursV2, spacing} from '@fo/shared/styles/variables';
import {ETheme} from '@fo/root/Templates/TideTemplates/shared/enums/themes';

const styles = {
  radioIconField: css`
    label: radioIconField;
    display: flex;
    justify-content: space-between;
    padding: ${spacing.XXS} 0 0;
    flex-wrap: wrap;
  `,
  button: (isSelected: boolean, isDisabled?: boolean, theme = ETheme.FO): string => css`
    label: radioIconField__button;
    display: flex;
    flex-basis: 30%;
    flex-direction: column;
    align-items: center;
    padding: ${spacing.XXS} 1.2rem ${spacing.XXS} 1.5rem;
    color: ${colours.font.ASSISTIVE};
    font-size: 1.2rem;
    line-height: 1.2;
    text-align: center;
    background-color: ${colours.general.WHITE};
    border: 1px solid ${colours.border.LIGHT_GRAY};
    outline: none;
    cursor: pointer;
    margin: 0;

    ${isSelected &&
    css`
      background: ${colours.selected.LIGHT_GRAY};
      border: 1px solid ${theme === ETheme.FO ? coloursV2.brand.primary : coloursV2.brand.secondary};
      box-shadow: inset 0px 0px 0px 1px ${coloursV2.brand.primary};
    `}

    &:hover,
    &:focus {
      background: ${colours.selected.LIGHT_GRAY};
    }

    ${isDisabled &&
    css`
      color: ${colours.semantic.DEFAULT_HOVER};
      background: ${colours.field.DISABLED};
      border: 1px solid ${colours.border.GRAY};
      pointer-events: none;
    `}
  `,
  image: css`
    label: radioIconField__image;
    display: block;
    margin: ${spacing.XXXS} auto;
    pointer-events: none;
  `,
};

export default styles;
